import React from 'react'

export const Blockquote = (props) => (
    <blockquote {...props} className="p-6 rounded bg-gray-accent-light dark:bg-gray-accent-dark" />
)
